module.exports = __webpack_public_path__ + "img/500.6d670f88.jpg";